// extracted by mini-css-extract-plugin
export var equalColumn = "_dt-0";